import { MotionConfig } from "framer-motion";
import { useLocation } from "react-router-dom";
import { useGuardedNavigate } from "../context/AuthModalContext";
import { useAuth } from "../context/AuthContext";
import CompleteSetupBanner from "./CompleteSetupBanner";
import PageTransition from "./motion/PageTransition";
import AppShell from "./shell/AppShell";

const Layout = ({
  children,
  isDark,
  toggleTheme,
  setToast,
}) => {
  const { user } = useAuth();
  const location = useLocation();
  const navigate = useGuardedNavigate();

  const searchParams = new URLSearchParams(location.search);
  const isBareMintWelcome = location.pathname === "/mint-space" && searchParams.get("welcome") === "1";

  const isAuthPage = location.pathname === "/auth";
  const isCreateCampaign =
    location.pathname === "/create-campaign" ||
    location.pathname === "/create-business" ||
    (location.pathname.includes("/campaigns/") && location.pathname.includes("/edit"));
  const isCampaignDetails = location.pathname.match(/^\/campaigns\/[^/]+$/) || location.pathname.match(/^\/mint-space\/[^/]+\/campaigns\/[^/]+$/); // Matches /campaigns/:id or /mint-space/:spaceId/campaigns/:id but not /campaigns/:id/edit
  const isMintSpaceRoute =
    (location.pathname === "/mint-space" || location.pathname.match(/^\/mint-space\/[^/]+$/)) &&
    !location.pathname.includes("/campaigns/");
  const isMintSpace = isMintSpaceRoute && !isBareMintWelcome;
  const isDashboard = location.pathname === "/dashboard";
  const isProductPage = /^\/mint-space\/[^/]+\/product(\/|$)/.test(location.pathname);
  const isCampaignWindow = isCreateCampaign || isCampaignDetails || isMintSpace || isDashboard;

  return (
    <MotionConfig reducedMotion="user">
      {!isAuthPage && isBareMintWelcome && (
        <main className="relative min-h-screen w-full overflow-auto bg-bg-base text-label-primary">
          <button
            type="button"
            onClick={() => navigate("/resources")}
            className="fixed left-4 top-4 z-[120] rounded-radius-md border border-white/15 bg-white/10 px-4 py-2 text-subheadline-semibold text-slate-100 backdrop-blur-md transition hover:bg-white/20"
          >
            ← Resources
          </button>
          <div className="min-h-[calc(100vh-4rem)] w-full pt-16">
            <PageTransition>{children}</PageTransition>
          </div>
        </main>
      )}

      {!isAuthPage && !isBareMintWelcome && (
        /* Figma "Shell · ეკრანის ჩარჩო": sidebar, top actions, Messages bar; tab bar on phones */
        <AppShell
          isDark={isDark}
          toggleTheme={toggleTheme}
          setToast={setToast}
          isWindow={isCampaignWindow}
          rail={isProductPage}
          flush={location.pathname.startsWith("/mint-space/")}
        >
          {!isCampaignWindow && !isProductPage && !location.pathname.startsWith("/messages") && user && (
            <CompleteSetupBanner user={user} isDark={isDark} />
          )}
          <PageTransition fillHeight={isCampaignWindow}>{children}</PageTransition>
        </AppShell>
      )}

      {isAuthPage && <PageTransition>{children}</PageTransition>}
    </MotionConfig>
  );
};

export default Layout;
